import React, { useEffect, useState } from "react";
import axios from "axios";

const ACCESS_TOKEN = 'IGAAfQvFhMnwtBZAGIxQnVnVWZAIcjdBajlKZAk5pSU8wTS1PUmtPWk9VZA1VFY29jbEVXS0o3UjluMldCeXI3bldfcTM1RWh4cEZAyTy1yaHJPUHE2Q3dNUEpkbDQwdHVCLTZAyNmFpclBUckl0TURaTjR3N1pOY25xM2FERmV2ME5SZAwZDZD';
// const USER_ID = "17841402886947362"; // From Step 3
const USER_ID = "me"; // From Step 3
const LIMIT = 6;

function InstagramFeed() {
  const [posts, setPosts] = useState([]);

  useEffect(() => {
    const fetchInstagramPosts = async () => {
      try {
        const response = await axios.get(
          // `https://graph.instagram.com/${USER_ID}/media?fields=id,caption,media_type,media_url,permalink,thumbnail_url,timestamp&access_token=${ACCESS_TOKEN}&limit=${LIMIT}`
          `https://graph.instagram.com/me/media?fields=id,caption,media_type,media_url,permalink,thumbnail_url,timestamp&access_token=${ACCESS_TOKEN}&limit=${LIMIT}`

        
        );
        setPosts(response.data.data);
      } catch (error) {
        // console.error("Error fetching Instagram posts:", error);
      }
    };

    fetchInstagramPosts();
  }, []);

  return (
   <div className="instagram-feed">
      {posts.map((post) => (
        <a
          href={post.permalink}
          key={post.id}
          className="instagram-link"
          target="_blank"
          rel="noopener noreferrer"
        >
          {post.media_type === "IMAGE" || post.media_type === "CAROUSEL_ALBUM" ? (
            <img
              src={post.media_url}
              alt={post.caption}
              className="instagram-post"
            />
          ) : post.media_type === "VIDEO" ? (
            <video className="instagram-post" controls>
              <source src={post.media_url} type="video/mp4" />
            </video>
          ) : null}
        </a>
      ))}
    </div>
  );
}

export default InstagramFeed;
